<div style="page-break-inside: avoid;" *ngIf="directorScheduling?.length || capitalPartnershipFirm?.length || businessCapitalExceptDirector?.length" class="mt-4" [ngClass]="{'container': !isSinglePageReturn, 'return-view-background-print': !isSinglePageReturn && printActive, 'return-view-background': !isSinglePageReturn && !printActive}">
    <div class="row mb-4">
        <div class="col-12 text-center">
            <strong>PARTICULARS OF BUSINESS CAPITALS</strong><br/>
            <i>[Attachment for serial no 8(b) & 8(c) of IT-10B (2023)]</i>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-6"><strong>Taxpayer Name:</strong> {{returnData?.profileData?.assesName}}</div>
        <div class="col-sm-6 text-right">
           <strong>Assessment Year:</strong> {{returnData?.submissionInfo?.assessmentYear}}
        </div>
    </div>
    <div class="row mt-3 mb-5">
        <div class="col-sm-12">
            <strong>TIN</strong>&ensp;&ensp;
            <span class="ml-3" style="white-space: nowrap;">
                <input value="{{item}}" *ngFor="let item of returnData?.profileData?.tin.split('')" class="input-default" disabled/>
            </span>
        </div>
    </div>

    <div *ngIf="directorScheduling?.length" style="page-break-inside: avoid" class="row mb-4">
        <div class="col-12 text-center mb-3 font-weight-bold">
            Director Shareholding
        </div>
        <div class="col-12">
            <table class="table table-bordered">
                <tbody>
                    <tr>
                        <td class="text-center" colspan="2">Name of the company</td>
                        <td class="text-center">Type of Account</td>
                        <td class="text-center">No. of share</td>
                        <td class="text-center">Value</td>
                    </tr>
                    <tr *ngFor="let item of directorScheduling; let i = index">
                        <td class="text-center">{{i+1}}</td>
                        <td class="text-start">{{item?.name}}</td>
                        <td class="text-start pr-3">{{item?.type}}</td>
                        <td class="text-start pr-3">{{item?.otherInfo}}</td>
                        <td class="text-right pr-3">{{item?.value | currencySeparatorBD}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div *ngIf="businessCapitalExceptDirector?.length" style="page-break-inside: avoid" class="row mb-4">
        <div class="col-12 text-center mb-3 font-weight-bold">
            Business Capital Other Than Directors Shareholdings In Limited Companies
        </div>
        <div class="col-12">
            <table class="table table-bordered">
                <tbody>
                    <tr>
                        <td class="text-center" colspan="2">Name of the Business</td>
                        <td class="text-center">Total Business Asset</td>
                        <td class="text-center">Business Liabilities</td>
                        <td class="text-center">Business Capital</td>
                    </tr>
                    <tr *ngFor="let item of businessCapitalExceptDirector; let i = index">
                        <td class="text-center">{{i+1}}</td>
                        <td class="text-start">{{item?.name}}</td>
                        <td class="text-right pr-3">{{item?.businessAssetValue | currencySeparatorBD}}</td>
                        <td class="text-right pr-3">{{item?.businessLiabilitiesValue | currencySeparatorBD}}</td>
                        <td class="text-right pr-3">{{item?.value | currencySeparatorBD}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div *ngIf="capitalPartnershipFirm?.length" style="page-break-inside: avoid" class="row mb-4">
        <div class="col-12 text-center mb-3 font-weight-bold">
            Capital of Partnership Firm
        </div>
        <div class="col-12">
            <table class="table table-bordered capital-table">
                <tbody>
                    <tr>
                        <td class="text-center" colspan="2">Name of Partnership Firm</td>
                        <td class="text-center">TIN of Firm</td>
                        <td class="text-center">Partners Capital</td>
                    </tr>
                    <tr *ngFor="let item of capitalPartnershipFirm; let i = index">
                        <td class="text-center">{{i+1}}</td>
                        <td class="text-start">{{item?.name}}</td>
                        <td class="text-start pr-3">{{item?.type}}</td>
                        <td class="text-right pr-3">{{item?.value | currencySeparatorBD}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
